<template>
  <div class="guide-step-1" v-if="isVisible">
    <!-- 箭頭指示器（向左指） -->
    <div class="guide-arrow">
      <svg width="40" height="24" viewBox="0 0 40 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M38 12L2 12M2 12L12 2M2 12L12 22" stroke="#F59E0B" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>

    <!-- 提示文字 -->
    <div class="guide-tip">
      <div class="guide-tip-main">
        {{ t('gameActManager.gameActGuide.step1.main') }}
      </div>
      <div class="guide-tip-sub">
        {{ t('gameActManager.gameActGuide.step1.sub') }}
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
import { ref, onMounted, defineExpose } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const isVisible = ref(false);

// 檢查是否需要顯示引導
const checkGuideStatus = () => {
  const hasSeenGuide = localStorage.getItem('hasSeenGameActivityGuide');
  // 如果未看過引導，則顯示
  if (!hasSeenGuide) {
    isVisible.value = true;
  }
};

// 隱藏引導（當使用者點擊「+ 新增」按鈕時調用）
const hideGuide = () => {
  isVisible.value = false;
  // 記錄使用者已看過步驟 1
  localStorage.setItem('hasSeenGameActivityGuideStep', 'step1');
};

// 暴露方法給父組件使用
defineExpose({
  hideGuide
});

onMounted(() => {
  checkGuideStatus();
});
</script>

<style lang="less" scoped>
.guide-step-1 {
  position: absolute;
  left: 175px; // 「+ 新增」按鈕右側，向右調整
  top: 10px; // 與按鈕對齊
  display: flex;
  align-items: center;
  gap: 0px;
  z-index: 50;
  pointer-events: none; // 不阻擋使用者操作
  animation: fade-in 0.3s ease-out;
}

.guide-arrow {
  svg {
    animation: bounce-horizontal 1.5s ease-in-out infinite;
  }
}

.guide-tip {
  background-color: rgba(255, 255, 255, 0.95);
  padding: 8px 12px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.guide-tip-main {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #262626;
  line-height: 1.6;

  .emoji {
    font-size: 16px;
  }
}

.guide-tip-sub {
  margin-top: 2px;
  font-size: 13px;
  font-weight: 400;
  color: #595959;
  line-height: 1.6;
}

// 動畫定義
@keyframes fade-in {
  0% {
    opacity: 0;
    transform: scale(0.95);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes bounce-horizontal {
  0%, 100% {
    transform: translateX(0px);
  }
  50% {
    transform: translateX(-6px);
  }
}

// 響應式設計
@media (max-width: 1024px) {
  .guide-step-1 {
    left: auto;
    right: 20px;
    top: 80px;
  }
}

@media (max-width: 768px) {
  .guide-step-1 {
    position: fixed;
    left: 50%;
    top: auto;
    bottom: 20px;
    transform: translateX(-50%);
    flex-direction: column;
    text-align: center;
  }

  .guide-arrow {
    transform: rotate(90deg); // 向上箭頭
  }

  .guide-tip {
    order: -1; // 文字在上方
  }
}
</style>
